import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllSystemsV2 } from '../../../../api/system';

const useSystemOrganization = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  parameters?: any
) => {
  return useQuery({
    queryKey: [
      'useSystemOrganization',
      parameters?.system_id,
      parameters?.locationId,
      parameters?.isOrganizationSet,
      parameters?.limit,
      parameters?.search,
    ],
    queryFn: () => getAllSystemsV2(parameters),
    ...options,
  });
};

export default useSystemOrganization;
